var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0733 5.0625H31.2648C30.871 5.0625 30.4974 5.2433 30.2563 5.55268L13.6907 26.538L5.74738 16.4732C5.62722 16.3207 5.47406 16.1973 5.29939 16.1124C5.12473 16.0275 4.9331 15.9833 4.7389 15.983H1.93042C1.66122 15.983 1.51256 16.2924 1.67729 16.5013L12.6822 30.4433C13.1965 31.0942 14.1849 31.0942 14.7032 30.4433L34.3264 5.57679C34.4911 5.37188 34.3425 5.0625 34.0733 5.0625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1abe20c0de59b07406f3bdb27ee4af27.svg";
export { ForwardRef as ReactComponent };